import { sendToApi } from 'api/client'
import {
  FileAccessGrant,
  Access,
  AssetAccessGrantWithParent,
  FileAccessGrantAccessor,
  ShareableFileType,
  Permission,
  RecipientsSelectorValueType,
} from 'types'

export interface FileWithIdAndType {
  id: string
  type: ShareableFileType
}

const AccessGrantsClient = (file: FileWithIdAndType) => {
  const assetTypeMap = {
    folder: 'Project',
    article: 'Article',
    handbook: 'Handbook',
    layer: 'Layer',
    media_file: 'MediaFile',
    design: 'Design',
    video: 'Video',
  }

  const fileParams = {
    asset_id: file.id,
    asset_type: assetTypeMap[file.type],
  }

  return {
    newList: () =>
      sendToApi<{
        current_user_highest_access?: Access
        current_user_inherited_access_grant?: FileAccessGrant | null
        public_access?: FileAccessGrant | null
        inherited_public_access?: FileAccessGrant | null
        main_accesses: FileAccessGrant[]
        inherited_accesses: FileAccessGrant[]
        asset: AssetAccessGrantWithParent
        main_layer_editors?: FileAccessGrantAccessor[]
      }>(`/access_grants_v2/`, {
        method: 'GET',
        params: fileParams,
      }),

    list: () =>
      sendToApi<{
        access_grants: FileAccessGrant[]
        current_user_access: FileAccessGrant
        current_workspace_access: FileAccessGrant
        public_access: FileAccessGrant
      }>(`/access_grants/`, {
        method: 'GET',
        params: fileParams,
      }),

    update: (id: number, access: Permission) =>
      sendToApi(`/access_grants/${id}`, {
        method: 'PUT',
        body: {
          access,
        },
      }),

    create: ({
      assetId,
      assetType,
      inviteMessage,
      access,
      inviteToWorkspace,
      recipients,
    }: {
      assetId: string
      assetType: ShareableFileType
      inviteMessage: string
      access: Permission
      inviteToWorkspace: boolean
      recipients: { id?: number; type: RecipientsSelectorValueType; email?: string }[]
    }) =>
      sendToApi(`/access_grants_v2`, {
        method: 'POST',
        body: {
          asset_id: assetId,
          asset_type: assetTypeMap[assetType],
          invite_message: inviteMessage,
          access: access,
          invite_to_workspace: inviteToWorkspace,
          recipients,
        },
      }),

    destroy: (accessGrant: FileAccessGrant) =>
      sendToApi(`/access_grants/${accessGrant.id}`, {
        method: 'DELETE',
      }),

    publish: (access: Permission, password?: string | null) =>
      sendToApi<{ public_access: FileAccessGrant }>(`/access_grants/publish`, {
        method: 'POST',
        body: {
          ...fileParams,
          access,
          password,
        },
      }),
  }
}

export default AccessGrantsClient
